var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"league",style:({ marginTop: _vm.$store.state.navbarHeight + 'px' })},[_c('v-main',[_c('transition',{attrs:{"name":"page","mode":"out-in"}},[_c('router-view',{key:_vm.$route.fullPath})],1)],1),_c('custom-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }